export default "__VITE_ASSET__Bntyl6Qa__"